import React from 'react';
import './index.scss';

const Section = (props) => {
    const {
        title,
        children,
        className = ''
    } = props;

    return (
        <div className={`section ${className}`}>
            <div className='section_title'>
                <div className='diamond'>
                    <div className='diamond_inner' />
                </div>
                <h2 className='section_title_text'>
                    {title?.toUpperCase()}
                </h2>
                <div className='diamond'>
                    <div className='diamond_inner' />
                </div>
            </div>
            <div className='section_display'>
                {children}
            </div>
        </div>
    );
};

export default Section;